// extracted by mini-css-extract-plugin
export var active = "expandable-module--active--InUNI";
export var button = "expandable-module--button--gdcYN";
export var content = "expandable-module--content--NhVbp";
export var dark = "expandable-module--dark--oNXmV";
export var icon = "expandable-module--icon--pXxnm";
export var label = "expandable-module--label--Gqqy0";
export var light = "expandable-module--light--Kvtuv";
export var primary = "expandable-module--primary--0aOHM";
export var wrapper = "expandable-module--wrapper--8vug9";